import styled from "@emotion/styled";

function LoadingSpinner() {
  return (
    <SpinnerWrapper aria-label="hidden">
      <Spinner viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="linearGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="5%" stopColor="#CEECB5" />
            <stop offset="30%" stopColor="#F7CFDA" />
            <stop offset="100%" stopColor="#CCA2F8" />
          </linearGradient>
        </defs>
        <circle cx="50" cy="50" r="45" stroke="url(#linearGradient)" />
      </Spinner>
      <SpinnerText>Loading</SpinnerText>
    </SpinnerWrapper>
  );
}
const SpinnerWrapper = styled.div(({ theme }) => ({
  alignItems: "center",
  bottom: 0,
  display: "flex",
  justifyContent: "center",
  left: 0,
  position: "fixed",
  right: 0,
  top: 0,
  zIndex: 10000,
}));

const Spinner = styled.svg({
  position: "relative",
  animation: "2s linear infinite svg-animation",
  maxWidth: 120,
  zIndex: 2,

  "@keyframes svg-animation": {
    "0%": {
      transform: "rotateZ(0deg)",
    },
    "100%": {
      transform: "rotateZ(360deg)",
    },
  },
  circle: {
    animation: "1.4s ease-in-out infinite both circle-animation",
    display: "block",
    fill: "transparent",
    strokeLinecap: "round",
    strokeDasharray: 283,
    strokeDashoffset: 280,
    strokeWidth: 10,
    transformOrigin: "50% 50%",
  },
  "@keyframes circle-animation": {
    "0%,25%": {
      strokeDashoffset: 280,
      transform: "rotate(0)",
    },

    "50%,75%": {
      strokeDashoffset: 75,
      transform: "rotate(45deg)",
    },

    "100%": {
      strokeDashoffset: 280,
      transform: "rotate(360deg)",
    },
  },
});
const SpinnerText = styled.div(({ theme }) => ({
  alignItems: "center",
  backdropFilter: "blur(10px)",
  backgroundColor: "rgba(255,255,255,.4)",
  borderRadius: theme.borderRadius.round,
  boxShadow: theme.boxShadow.light,
  color: "#7f58a8",
  display: "flex",
  fontSize: theme.fontSizes.xs,
  fontWeight: "bold",
  height: 160,
  justifyContent: "center",
  left: "50%",
  position: "absolute",
  top: "50%",
  transform: "translate(-50%, -50%)",
  width: 160,
  zIndex: 1,
}));
export { LoadingSpinner };
